import * as React from 'react';
import { FunctionComponent } from 'react';
import GITextIntl from '../../components/common/app-components/GIText/GITextIntl';

interface ITobaccoAlertProps {
  messageId: string;
  id: string;
  textReplacements?: { [key: string]: any };
}

const TobaccoAlert: FunctionComponent<ITobaccoAlertProps> = ({ messageId, id, textReplacements }) => {

  return (
    <>
      <div className = 'usa-alert usa-alert--info gi-alert gi-alert__info' >
        <div className = 'usa-alert__body gi-alert__info__body' >
          <p className = 'usa-alert__text gi-alert__info__text' >
            <GITextIntl messageId={messageId} id={id} textReplacements={textReplacements} shouldParse={true}/>
          </p>
        </div>
      </div>
    </>
  );
};
export default TobaccoAlert;